import { BaseComponentConfig } from '@interfaces/config/cms-components/base-config';
import { CmsComponentTypeEnum } from '@models/enums';
import { TextMediaBox } from '@interfaces/config';

export namespace NavigationWidget {
  export const TypeEnum = CmsComponentTypeEnum.NAVIGATION_WIDGET;

   export interface AnchorConfig {
      anchor_id: string;
      anchor_name:string;
    }

  export interface ComponentConfig extends BaseComponentConfig {

    anchor_id?:string,
    anchors :AnchorConfig[],

  }
}
